import React from 'react';
import { useLocation } from 'react-router-dom';
import brandsImg from 'assets/images/brands.png';
import grayBrandImg from 'assets/images/gray-brand.png';

const BRAND_BASE_PATH = '/hyperwolf/brands';

export default function BrandIcon(props) {
  const { color, ...rest } = props || {};
  const location = useLocation();
  const pathname = location?.pathname || '';

  const isActive =
    color === 'primary' ||
    pathname === BRAND_BASE_PATH ||
    pathname.startsWith(`${BRAND_BASE_PATH}/`);

  const src = isActive ? brandsImg : grayBrandImg;

  return (
    <img
      src={src}
      alt="Brands"
      width={24}
      height={24}
      style={{ display: 'block', objectFit: 'contain' }}
      {...rest}
    />
  );
}
